module.exports = __webpack_public_path__ + "static/index/img/baikal-503.961605da.jpg";